import { render, staticRenderFns } from "./SessionItemName.vue?vue&type=template&id=6420dcb3&"
import script from "./SessionItemName.vue?vue&type=script&lang=js&"
export * from "./SessionItemName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports